<script setup lang="ts">
import type {Schema, SchemaValue} from '@/generated-report/interfaces';
import FormField from "@/generated-report/components/form-schema/FormField.vue";

defineProps<{
    schema: Schema;
}>();

const value = defineModel<SchemaValue>({required: true});
</script>

<template>
  <div class="bg-gray-100 rounded-lg p-4">
    <FormField v-model="value" :schema="schema" />
  </div>
</template>

<style scoped>
:deep(textarea:not(:focus)) {
    overflow: hidden;
}
</style>
